import { render } from "./AttributeColor.vue?vue&type=template&id=fba44e72"
import script from "./AttributeColor.vue?vue&type=script&lang=js"
export * from "./AttributeColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__